import React from 'react';

import { config } from './app.config';

interface WebOnlyFeatProps {
  children: React.ReactNode;
}

export const WebOnlyFeat = ({ children }: WebOnlyFeatProps) =>
  config.app.isTeamsApp ? null : <>{children}</>;
